import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

import { Link } from 'react-router-dom';
// import { ROUTE_NAMES } from '../../Routes';

// import GetInTouchSection from '../../Components/GetInTouchSection';
// import StayConnected from '../../Components/StayConnectedSection';

// import RightArrow from '../../assets/images/right-arrow.png';

export default function ConstructionServices() {
  const location = useLocation();

  const canonicalUrl = `https://www.thestarlifegroup.com${location.pathname}`;

  return (
    <div className='service-page'>
      <Helmet>
        <title>Starlife: Construction Services</title>
        <meta
          name='description'
          content='Long after the ribbon is cut, we keep your investment performing beautifully.'
        />
        <meta
          name='keywords'
          content='Starlife, Asset & Property Services, investment, property management, real estate, investment performance'
        />
        <link rel='canonical' href={canonicalUrl} />
      </Helmet>
      <div className='service-context'>
        <h2 className='service-page-title'>
          Construction Services | Built to last. Delivered with precision
        </h2>
        <p className='service-page-text'>
          Through Starlife Builders, our licensed general contracting division,
          we deliver high quality construction management with a focus on
          craftsmanship, compliance, and efficiency from the ground up.
        </p>
      </div>
      <div className='our-services-section'>
        <h2 className='section-title'>Services</h2>
        <div className='service-list'>
          <Link
            // to={ROUTE_NAMES.ELITEPROPERTYMANAGMENT}
            className='service-block'
          >
            <h3>Licensed general contracting through Starlife Builders</h3>
            {/* <button className='right-arrow-btn'>
              <img src={RightArrow} alt='right-arrow' />
            </button> */}
          </Link>
          <Link
            // to={ROUTE_NAMES.ELITEPROPERTYMANAGMENT}
            className='service-block green-block'
          >
            <h3>Full construction management from planning to delivery</h3>
            {/* <button className='right-arrow-btn'>
              <img src={RightArrow} alt='right-arrow' />
            </button> */}
          </Link>
          <Link
            // to={ROUTE_NAMES.ELITEPROPERTYMANAGMENT}
            className='service-block'
          >
            <h3>Quality assurance, budget control, and on site execution</h3>
            {/* <button className='right-arrow-btn'>
              <img src={RightArrow} alt='right-arrow' />
            </button> */}
          </Link>
        </div>
      </div>
      {/* <GetInTouchSection /> */}
      {/* <StayConnected /> */}
    </div>
  );
}
